// @flow
import * as React from 'react';
import Container from './Container';

import TextSmall from './TextSmall';

type TProps = {
  merchant: any,
  onClick?: () => void,
};

export default function ListItemMerchant(props: TProps): React.Node {
  return (
    <Container flex align="center" px={24} py={16} onClick={props.onClick} hoverFill={props.onClick ? 'rgba(0, 0, 0, 0.05)' : undefined}>
      <Container mr={16}>
        <img width="48px" height="48px" alt="result" src={props.merchant.logo} />
      </Container>
      <Container flex="column">
        {props.merchant.parent_name}
        <TextSmall color="#4b4b4b">{props.merchant.name}</TextSmall>
      </Container>
    </Container>
  );
}
